import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '@baaligames/shared-ui/lib/api';
import { useT } from '@baaligames/shared-ui/lib/i18n';
import Icon from '@baaligames/shared-ui/components/Icon';

export default function VerifyEmail() {
  const t = useT();
  const [sp] = useSearchParams();
  const [state, setState] = useState<'loading'|'ok'|'err'>('loading');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    const token = sp.get('token');
    if (!token) { setState('err'); setMsg('Missing token'); return; }
    (async () => {
      try {
        await api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`);
        setState('ok');
      } catch (e) {
        setState('err');
        setMsg((e as ApiError).message);
      }
    })();
  }, [sp]);

  return (
    <div className="auth-shell">
      <div className="auth-card text-center">
        <div className="auth-head">
          <div className="auth-head-badge">
            <Icon name={state === 'ok' ? 'verified' : state === 'err' ? 'error' : 'mark_email_read'} size={22} />
          </div>
          <h1 className="auth-h1">
            {state === 'loading' && t('verify.email.verifying')}
            {state === 'ok' && t('verify.email.title')}
            {state === 'err' && t('verify.email.failed')}
          </h1>
          {state === 'ok' && <p className="auth-sub">{t('verify.email.sub')}</p>}
          {state === 'err' && <p className="auth-sub">{msg}</p>}
        </div>

        {state === 'loading' && (
          <div className="flex items-center justify-center gap-2 text-arena-500 dark:text-neon-200/70 py-2">
            <Icon name="progress_activity" className="animate-spin" />
          </div>
        )}

        {state === 'ok' && (
          <Link to="/login" className="auth-cta inline-flex">
            {t('common.signIn')} <Icon name="arrow_forward" />
          </Link>
        )}

        {state === 'err' && (
          <Link to="/register" className="auth-cta-ghost inline-flex">
            <Icon name="arrow_back" /> {t('verify.backRegister')}
          </Link>
        )}
      </div>
    </div>
  );
}
